import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Header, PageTitle } from '@/components'
import { Button, Card } from '@/components/ui'
import { Plus } from 'lucide-react'
import Loader from '../../../common/components/Loader'
import { IColumn, Table } from '../../../core/components/Table'
import {
  IFestivalMenuItem,
  getFestivalsMenu,
} from '../../../core/services/menu'
import { MessageBox } from '../messages/MessageBox'
import { Icon } from '@/common/components/Icon'

export const FestivalsPage: React.FC = (): JSX.Element => {
  const [festivals, setFestivals] = useState<IFestivalMenuItem[]>([])
  const [isError, setIsError] = useState<boolean>(false)
  const [showMessageBox, setShowMessageBox] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)

  const navigate = useNavigate()

  const getData = useCallback(async () => {
    try {
      setLoading(true)
      const response = await getFestivalsMenu()
      setFestivals(response.data)
    } catch (e) {
      if (e instanceof Error) {
        setIsError(true)
        setShowMessageBox(true)
        setMessage(e.message)
      } else {
        console.error(e)
      }
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    getData()
  }, [getData])

  const columns: IColumn[] = [
    {
      title: 'Festivals',
      accessor: 'name',
    },
    {
      title: 'View',
      accessor: '',
      render: (row) => (
        <a
          className="view text-accent-1 underline cursor-pointer"
          href="#"
          onClick={(e) => {
            e.preventDefault()
            navigate(`/settings/festivals/${row.name}`)
          }}
        >
          View
        </a>
      ),
    },
  ]

  return (
    <>
      <Header
        pageTitle="Festivals"
        actions={
          <Button
            onClick={() => {
              navigate('/settings/festivals/New Festival')
            }}
          >
            Add New
            <Icon
              icon="plus-circle"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
            />
          </Button>
        }
      />
      {loading && <Loader />}
      <Card className="p-5 !bg-monochrome-4-60">
        <PageTitle title="Settings" subtitle="Festivals" />
        <Table columns={columns} data={festivals} />
      </Card>
      <MessageBox
        message={message}
        setShowMessageBox={setShowMessageBox}
        showMessageBox={showMessageBox}
        isError={isError}
      />
    </>
  )
}
